
import { IAdminEvent } from '@/interfaces/entities/admin-event';
import { ApiRequestConfig, apiService } from './api.service';

import { IApiService } from '@/interfaces/services/IApiService';

class AdminEventService {
    api: IApiService<ApiRequestConfig>;

    constructor(api: IApiService<ApiRequestConfig>) {
        this.api = api;
    }

    async getAllAdminEvents(pageNumber: number, config?: ApiRequestConfig) {
        return await this.api.get<{ data: IAdminEvent[]; pageCount: number }>(
            `/adminEvent?page[number]=${pageNumber}&sort[id]=DESC`,
            config,
        );
    }

    async deleteAdminEvent(id: number) {
        return await this.api.delete(`/adminEvent/${id}`);
    }

    async editAdminEvent(id: number, adminEvent: FormData) {
        return await this.api.patch(`/adminEvent/edit/${id}`, adminEvent, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    }

    async newAdminEvent(adminEvent: FormData) {
        return await this.api.post(`/adminEvent`, adminEvent, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    }
}

export const adminEventService = new AdminEventService(apiService);